const social = [
	{ path: 'https://github.com/Daatwood/', name: 'Github', color: '#444' },
	{ path: 'https://www.linkedin.com/in/dustin-atwood-15561212a/', name: 'Linkedin', color: '#0073a4' },
	{ path: 'https://twitter.com/dustin_atwood', name: 'Twitter', color: '#00aced' }
];

export default social;



// WEBPACK FOOTER //
// ./src/routes/social.js